import React from 'react';
import { Outlet } from 'react-router-dom';
import { PERMISSIONS } from '../../../../utils/permissions';
import { RequirePermission } from '../RequirePermission';

/**
 * The migration's pages, for users whose token grants admin:migration — the people running the switch, not every
 * data manager; viewer-api checks it again on every call.
 */
export function MigrationGate() {
  return (
    <RequirePermission
      permission={PERMISSIONS.ADMIN_MIGRATION}
      message={
        <>
          <p className="mb-2">
            This page is for the people running the data migration. Your account does not have the{' '}
            <code>{PERMISSIONS.ADMIN_MIGRATION}</code> permission.
          </p>
          <p className="mb-2">
            If you need it, ask an administrator to give it to your account, then sign out and in
            again.
          </p>
        </>
      }
    >
      <Outlet />
    </RequirePermission>
  );
}

export default MigrationGate;
